import { IFlagData, IUserTailoring, IFlagStrategy, ICoreFlagMgr, IUser } from '@nab/x-types';
import { sdkLoggerInterface as log } from '../Logger/Logger';

export class UserTailoring implements IUserTailoring {
    constructor(private appId: string, private user: IUser, private coreFlagMgr: ICoreFlagMgr) {}

    /**
     * Register a strategy for your miniapp.
     * @param flagStrategy What strategy would you like to register for said miniapp.
     * @example
     * ```typescript
     * // App.tsx
     * import { useUser } from '@nab/nab-x-react';
     * ...
     * const user = useUser();
     *
     * useEffect(() => {
     *  try {
     *      (async () => {
     *          await user.setFlagStrategy(new LaunchDarklyFlagStrategy('your-api-key-for-launchdarkly'));
     *           setShowGraphQLComp(user.checkFlag('graphql', false));
     *       })();
     *   } catch (e) {
     *       new Error('Error: Unable to get token');
     *   }
     *  }, [user]);
     * ```
     */
    public async setFlagStrategy(flagStrategy: IFlagStrategy) {
        return this.coreFlagMgr.setFlagStrategy(this.user, flagStrategy, this.appId);
    }

    /**
     * Retrieve the flag value.
     * @param flagName The flag value you want to retrieve.
     * @param defaultValue The value you wish to return in case of an uncaught exception or if the strategy has not been initialised.
     */
    public checkFlag<T = IFlagData>(flagName: string, defaultValue: T): T {
        const result = this.coreFlagMgr.checkFlag<T>(this.appId, flagName, defaultValue);
        log.info(`checkFlag: ${flagName} = ${result}`);
        return result;
    }

    public areFlagsReady(): boolean {
        return this.coreFlagMgr.areFlagsReady(this.appId);
    }

    public whenFlagsReady(): Promise<void> {
        return this.coreFlagMgr.whenFlagsReady(this.appId);
    }

    public hasCapability(capability: string) {
        return true;
    }
}
